import { Box, Pagination as MUIPagination } from '@mui/material';
import React, { useMemo } from 'react';
import { PAGE_LIMIT } from 'shared/constants/pagination';

import { Props } from './types';

function Pagination({
    page,
    pageLimit = PAGE_LIMIT,
    onChange,
    recordsCount,
    testID,
}: Props) {
    const numberOfPages = useMemo(() => {
        if (!recordsCount) return -1;
        return Math.ceil(recordsCount / pageLimit);
    }, [recordsCount, pageLimit]);

    return (
        <Box
            sx={{
                paddingBlock: 3,
                display: 'flex',
                justifyContent: 'flex-end',
            }}
        >
            <MUIPagination
                data-test-id={testID}
                shape="rounded"
                page={page}
                count={numberOfPages}
                onChange={onChange}
            />
        </Box>
    );
}

export default Pagination;
